import React, { useEffect, useState } from "react";
import "./style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "../../../../components/sidebar";
import { useOutletContext, useParams } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { propertyDetails } from "../../../../core/data/redux/property/_propertyAction";
import { formatOwnership } from "../../../../constants/common";

const CpaPropertiesDetail = () => {
  const { isSidebarOpen } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();
  const dispatch: any = useDispatch();
  const { id } = useParams<{ id: string }>();

  const [property, setProperty] = useState<any>({});
  const [completeAddress, setCompleteAddress] = useState<string>("");

  useEffect(() => {
    getPropertyDetails();
  }, [dispatch]);

  const getPropertyDetails = async () => {
    try {
      const response = await dispatch(propertyDetails({ uuid: id }));
      const propertyData = response?.payload?.data;
      setProperty(propertyData);
      setCompleteAddress(propertyData?.address + ", " + propertyData?.city + ", " + propertyData?.state + ", " + propertyData?.zipcode);
    } catch (error) {
      console.error("Failed to load property", error);
    }
  };


  return (
    <div className="layout">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Main Content */}
      <main className="content mb-5">
        <div className="nonreal-property-detail-page profileSettings p-4">
          <div className="nonreal-property-detail-top-section profileSettings p-4">
            <h2 className="mb-4 d-flex">
              <img
                className="me-3"
                src="/assets/img/building-image.svg"
                alt="Building"
              />
              Property Detail
            </h2>

            <Container fluid className="px-0">
              <Form>
                <Row className="mb-3">
                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label>Property Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={property?.name || ""}
                        readOnly
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label>Complete Address</Form.Label>
                      <Form.Control
                        type="text"
                        value={completeAddress || ""}
                        readOnly
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        value={property?.city || ""}
                        readOnly
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label>State</Form.Label>
                      <Form.Control
                        type="text"
                        value={property?.state || ""}
                        readOnly
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label>ZIP Code</Form.Label>
                      <Form.Control
                        type="number"
                        value={property?.zipcode || ""}
                        readOnly
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label>Ownership Type</Form.Label>
                      <Form.Control
                        type="text"
                        value={property?.ownership ? formatOwnership(property?.ownership) : ""}
                        readOnly
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label>Category</Form.Label>
                      <Form.Control
                        type="text"
                        value={property?.category?.name.toUpperCase() || ""}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Container>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CpaPropertiesDetail;
